import axios from 'axios';
import { history } from "../store/configureStore";
import { toastr } from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as types from '../constants/actionTypes';
import * as api from '../tools/apiConfig';
import { configureStore}  from '../store/configureStore'
// const history = createhistory();

export function getUserDetails(data) {
	return function (dispatch, getState) {
		axios.post(api.GET_USER_DETAILS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_USER_DETAILS, userDetails: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}
export function deleteImageProfile(data){

	return function (dispatch, getState) {
		axios.post(api.DELETE_PROFILE_IMAGE, data ,{
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		}).then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					let user = JSON.parse(localStorage.getItem('user'));
					user.image = response.data.data.profileImage;
					localStorage.setItem('user', JSON.stringify(user));
					let userDetail = {
						userId: localStorage.getItem('userId')
					}
					axios.post(api.GET_USER_DETAILS, userDetail, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								dispatch({ type: types.GET_USER_DETAILS_FOR_IMAGE, userDetails: user})

								return dispatch({ type: types.GET_USER_DETAILS, userDetails: response.data.data });
							}
						})
						.catch(function (error) {
						});				}
			})
			.catch(function (error) {
			});
	}
}
export function getBloodGroupList() {
	return function (dispatch, getState) {
		axios.get(api.GET_BLOOD_GROUP_LIST, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_BLOOD_GROUP_LIST, bloodGroupList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function updateUserProfile(data) {
	if (!data.hasOwnProperty('userId')) {
		data.userId = localStorage.getItem('userId');
	}
	
	return function (dispatch, getState) {
		axios.post(api.UPDATE_USER_PROFILE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				// debugger;
				
				if (response.data.code == 200) {
					localStorage.setItem('user', JSON.stringify(response.data.data));
					
					// configureStore.dispatch('/dashboard')
					// history.location = '/dashboard/my-appointment'
					// history.location = '/dashboard/my-setting'
					// history.push('/dashboard/my-appointment');
					// history.push('/dashboard/my-setting');
					dispatch({ type: types.GET_USER_DETAILS_ON_UPDATE, userDetails: response.data.data})

					toast.info(response.data.message);
					if (localStorage.getItem('availabilityId') && (localStorage.getItem('availabilityId') != null && localStorage.getItem('availabilityId') != '') && localStorage.getItem('fromMarketPage') && (localStorage.getItem('fromMarketPage') != null && localStorage.getItem('fromMarketPage') != false)) {
						history.push('/book-appointment-calendar');
					}
					let userDetail = {
						userId: localStorage.getItem('userId')
					}
					if(response.data.message == 'An email has been sent to you to change your email id'){
						// debugger;
						localStorage.clear();
						history.push('/');
						toast.info("Activation link has been send to your Email id");
					}

				} else if (response.data.code == 401) {
					toast.error(response.data.message);

				}
				else {
					localStorage.clear();
					history.push('/');
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				toast.error('Server is busy !Please try latter');
			});
	}
}

export function uploadPatientImage(data) {
	return function (dispatch, getState) {
		const formdata = new FormData();
		formdata.append('file', data.file);
		formdata.append('userId', data.userId);
		axios.post(api.UPLOAD_PATIENT_IMAGE, formdata, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token

			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// return dispatch({ type: types.GET_PATIENT_IMAGE, latestPatientImage: response.data.data })
					let user = JSON.parse(localStorage.getItem('user'));
					user.image = response.data.data;
					localStorage.setItem('user', JSON.stringify(user));
					// toast.info(response.data.message);
					let userDetail = {
						userId: localStorage.getItem('userId')
					}
	axios.post(api.GET_USER_DETAILS, userDetail, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					dispatch({ type: types.GET_USER_DETAILS_FOR_IMAGE, userDetails: user})

					return dispatch({ type: types.GET_USER_DETAILS, userDetails: response.data.data });
				}
			})
			.catch(function (error) {
			});
				} else if (response.data.code == 401) {
					toast.error(response.data.message);

				}
				else {
					localStorage.clear();
					history.push('/');
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function changePassword(data) {
	return function (dispatch, getState) {
		axios.post(api.CHANGE_PASSWORD_FROM_PROFILE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token

			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.SPECIALIST_PASSWORD_CHANGE_SUCCESS})
					// toast.info(response.data.message);
				} else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/');
					toast.error(response.data.message);
				}
				else {
					toast.error(response.data.message);

				}
			})
			.catch(function (error) {
				
			});
	}
}

export function verifyPassword(data) {
	return function (dispatch, getState) {
		axios.post(api.VERIFY_PASSWORD, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token

			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.VERIFY_PASSWORD, passwordData: response.data.data.status })
				} else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/');
					toast.error(response.data.message);
				}
				else {
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function getUserNotifications(data) {
	return function (dispatch, getState) {
		axios.post(api.GET_USER_NOTIFICATIONS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_USER_NOTIFICATIONS, userNotifications: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}
export function clearNotifications(data) {
	return function (dispatch, getState) {
		axios.post(api.CLEAR_ALL_NOTIFICATIONS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// toast.info(response.data.message);

					axios.post(api.GET_USER_NOTIFICATIONS, data, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								toast.info('Notification Cleared Successfully');
								setTimeout(function () {
									return dispatch({ type: types.GET_USER_NOTIFICATIONS, userNotifications: response.data.data });

								}, 2000);
							}
						})
						.catch(function (error) {
						});		}
			})
			.catch(function (error) {
			});
	}
}
export function deletePatientAccount(data) {
	return function (dispatch, getState) {
		axios.post(api.DELETE_USER_ACCOUNT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// return dispatch({ type: types.DELETE_USER_ACCOUNT, userNotifications: response.data.data });
					history.push('/')
				}
			})
			.catch(function (error) {
			});
	}
}
// export function getUsers(data) {

// 	return function (dispatch, getState) {

// 		axios.post(api.GET_USERS, data, {
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'Authorization': 'Bearer ' + localStorage.token
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					return dispatch({ type: types.GET_USERS, usersList: response.data.data });
// 				}
// 			})
// 			.catch(function (error) {
// 			});
// 	}
// }



// export function getRoles(data) {

// 	return function (dispatch, getState) {
// 		axios.post(api.GET_ROLES, data, {
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'Authorization': localStorage.token
// 			}
// 		})
// 			.then(function (response) {

// 				if (response.data.code == 200) {
// 					return dispatch({ type: types.GET_ROLES, userRoles: response.data.data });
// 				}
// 			})
// 			.catch(function (error) {
// 			});
// 	}
// }

// export function updateUserRoles(data) {

// 	return function (dispatch, getState) {
// 		axios.post(api.UPDATE_ROLES, data, {
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'Authorization': localStorage.token
// 			}
// 		})
// 			.then(function (response) {

// 				if (response.data.code == 200) {
// 					toastr.clear();
// 					setTimeout(function () {
// 						toastr.success(response.data.message);
// 					}, 400);
// 					// toastr.success(response.data.message);
// 				}
// 				else if (response.data.code == 402) {
// 					localStorage.clear();
// 					history.push('/');
// 					toastr.error(response.data.message);
// 				}
// 			})
// 			.catch(function (error) {
// 			});
// 	}
// }

// export function updateUserDetails(data, updatedData) {

// 	return function (dispatch, getState) {
// 		axios.post(api.UPDATE_ROLES, data, {
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'Authorization': localStorage.token
// 			}
// 		})
// 			.then(function (response) {

// 				if (response.data.code == 200) {
// 					updatedData.firstname = data.firstName;
// 					updatedData.lastname = data.lastName;
// 					updatedData.name = data.firstName + ' ' + data.lastName;
// 					toastr.success(response.data.message);
// 					return dispatch({ type: types.GET_USER_DETAILS, userData: updatedData });

// 				}
// 				else if (response.data.code == 402) {
// 					localStorage.clear();
// 					history.push('/');
// 					toastr.error(response.data.message);
// 				}
// 			})
// 			.catch(function (error) {
// 				
// 			});
// 	}
// }

// export function updateUserPicture(fileData, userId, updatedData) {

// 	return function (dispatch, getState) {
// 		var fd = new FormData();
// 		if (fileData) {
// 			fd.append("file", fileData);
// 		}
// 		fd.append("id", userId);
// 		axios.post(api.UPDATE_USER_PIC, fd, {
// 			headers: {
// 				'Authorization': localStorage.token
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					updatedData.userImage = response.data.userImage;
// 					toastr.success(response.data.message);
// 					return dispatch({ type: types.GET_USER_DETAILS, userData: updatedData });

// 				}
// 				else if (response.data.code == 402) {
// 					toastr.success(response.data.message);
// 				}
// 			})
// 			.catch(function (error) {
// 			});
// 	}
// }

// export function removeUserPicture(data, updatedData) {

// 	return function (dispatch, getState) {
// 		axios.post(api.REMOVE_USER_PIC, data, {
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'Authorization': localStorage.token
// 			}
// 		})
// 			.then(function (response) {

// 				if (response.data.code == 200) {
// 					updatedData.userImage = "";
// 					toastr.clear();
// 					toastr.success(response.data.message);
// 					return dispatch({ type: types.GET_USER_DETAILS, userData: updatedData });

// 				}
// 				else if (response.data.code == 401) {
// 					toastr.clear();
// 					toastr.error(response.data.message);
// 				}
// 				else if (response.data.code == 402) {
// 					localStorage.clear();
// 					history.push('/');
// 					toastr.error(response.data.message);
// 				}
// 			})
// 			.catch(function (error) {
// 			});
// 	}
// }



export function unsubscribeEmailsViaProfile(data) {
	return function (dispatch, getState) {
		axios
			.post(api.UNSUBSCRIBE_EMAILS_VIA_PROFILE, JSON.stringify(data), {
				headers: {
					"Content-Type": "application/json",
					'Authorization': 'Bearer ' + localStorage.token
				}
			})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					response.data.data.success = true;

					return dispatch({
						type: types.UNSUBSCRIBE_EMAILS_VIA_PROFILE,
						data: response.data.data
					});
				} else {
					// toast.error(response.data.message);
					response.data.data.success = false;
					return dispatch({
						type: types.UNSUBSCRIBE_EMAILS_VIA_PROFILE,
						data: response.data.data
					});
				}
			})
			.catch(function (error) {
				// toast.error(error);
			});
	};
}



export function resetChangingPasswordSuccessMsg() {
	return function (dispatch, getState) {
	    return dispatch({ type: types.RESET_SPECIALIST_PASSWORD_CHANGE_SUCCESS})
	};
}